import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MultilingualService } from 'src/app/core/services/multilingual/multilingual.service';
import { AppCenterAnalytics } from 'src/app/services/app-insights/app-insights';
import { AppInsightsService } from 'src/app/services/app-insights/app-insights.service';

@Component({
  selector: 'app-common-confirmation-popup',
  templateUrl: './common-confirmation-popup.component.html',
  styleUrls: ['./common-confirmation-popup.component.scss']
})
export class CommonConfirmationPopupComponent implements OnInit {
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: 
    {
      title?: string,
      msg: string, 
      type?: 'Reminder' | 'Charge_Ship';
      confirmButtonText?: string,
      showCancelButton?: boolean,
      cancelButtonText?: string
    },
    public dialogRef: MatDialogRef<CommonConfirmationPopupComponent>,
    public readonly multilingualService: MultilingualService,
    public readonly appInsightsService: AppInsightsService) { 
  }

  ngOnInit(): void {
  }
  close(action: 'confirm' | 'cancel' | null = null) {
    if(this.data.type) {
      (this.data.type == 'Reminder' && action == 'confirm') ? this.appInsightsService.trackPageView(AppCenterAnalytics.REFILL_REMINDER_CONFIRM_BUTTON_CLICKED)
      :this.appInsightsService.trackPageView(AppCenterAnalytics.REFILL_REMINDER_CANCEL_BUTTON_CLICKED)
    }
    this.dialogRef.close(action);
  }
}